import React from "react";

const ToggleSwitch = ({ label, checked, onChange }) => {
  return (
    <label className="flex items-center cursor-pointer select-none">
      <div className="relative">
        <input
          type="checkbox"
          className="sr-only"
          checked={checked}
          onChange={onChange}
        />
        <div
          className={`block w-12 h-6 rounded-full border border-border transition-colors ${
            checked ? "bg-primary-dark border-transparent" : "bg-muted"
          }`}
        />
        <div
          className={`absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-card shadow-sm border border-border transition-transform ${
            checked ? "translate-x-5" : ""
          }`}
        />
      </div>
      {label ? (
        <div className="ml-3 text-foreground font-medium">{label}</div>
      ) : null}
    </label>
  );
};

export default ToggleSwitch;
